import React from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon';

export default class UnlockedIcon extends Icon {
  gradientId = this.getRandomId();

  icon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
    >
      <g fill="none" fillRule="evenodd" transform="translate(1 1)">
        <circle
          cx="13"
          cy="13"
          r="13"
          fill="#E9E9E9"
          stroke="#FFF"
          strokeWidth="2"
        />
        <path
          fill="#485465"
          d="M9.93 11.228c-.25-.09-.526.038-.616.288l-1.74 4.782c-.092.25.037.526.286.616l6.346 2.31c.25.09.526-.038.617-.288l1.74-4.782c.09-.25-.038-.526-.287-.616l-6.346-2.31zm-2.618 7.194c-1.08-.393-1.638-1.592-1.245-2.672l1.74-4.783c.3-.822 1.067-1.362 1.933-1.372l.529-1.453c.801-2.071 3.07-3.13 5.167-2.415l.08.028c1.932.703 3.053 2.747 2.608 4.754-.034.156-.134.29-.274.366-.137.076-.3.088-.447.035l-.484-.177c-.255-.092-.4-.358-.345-.63.24-1.196-.41-2.387-1.546-2.833l-.058-.022c-1.27-.462-2.703.187-3.197 1.446l-.481 1.323 5.533 2.013c1.079.393 1.637 1.592 1.244 2.672l-1.74 4.783c-.394 1.08-1.592 1.64-2.671 1.246l-6.346-2.31z"
        />
      </g>
    </svg>
  );
}

UnlockedIcon.defaultProps = {
  opacity: '1.0',
};

UnlockedIcon.propTypes = {
  opacity: PropTypes.string,
};
